(function(){
  if (window.__ntfGiftChoiceInit) return; window.__ntfGiftChoiceInit = true;

  var state = null;

  function fmt(cents){
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'EUR';
    
    var round = (cents % 100) === 0;
    try {
      return new Intl.NumberFormat('nl-NL', { style:'currency', currency:cur,
        minimumFractionDigits: round ? 0 : 2, maximumFractionDigits: round ? 0 : 2 }).format(cents/100);
    }
    catch(e){ return (round ? String(cents/100) : (cents/100).toFixed(2).replace('.', ',')) + ' ' + cur; }
  }
  function fmtRound(cents){
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'EUR';
    try { return new Intl.NumberFormat('nl-NL', { style:'currency', currency:cur,
      minimumFractionDigits:0, maximumFractionDigits:0 }).format(cents/100); }
    catch(e){ return Math.round(cents/100) + ' ' + cur; }
  }
  
  function descBlock(d){
    var items = (d && d.descItems) || [];
    if (items.length > 1){
      return '<ul class="gcp-dlist">' + items.map(function(t){ return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>';
    }
    return (d && d.desc) ? '<p class="gcp-ddesc">' + esc(d.desc) + '</p>' : '';
  }
  
  function TX(key, vars, fallback){
    return (typeof window.NTF_T === 'function') ? window.NTF_T(key, vars, fallback) : (fallback || '');
  }
  
  function TXH(key, vars, fallback){
    return (typeof window.NTF_TH === 'function') ? window.NTF_TH(key, vars, fallback) : (fallback || '');
  }
  
  function tierCopy(tiers){
    if (typeof window.NTF_TIER !== 'function' || !Array.isArray(tiers)) return tiers;
    tiers.forEach(function(t){
      if (!t || !t.label) return;
      var tr = window.NTF_TIER(String(t.label).split('|')[0].trim());
      if (!tr) return;
      if (tr.full) t.label = tr.short ? (tr.full + '|' + tr.short) : tr.full;
      if (tr.desc) t.desc = tr.desc;
    });
    return tiers;
  }
  function esc(s){ return (s||'').replace(/[&<>"]/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  
  function fullLabel(label){
    return String(label || '').split('|')[0].trim();
  }
  function shortLabel(label){
    var parts = String(label || '').split('|');
    if (parts.length > 1 && parts[1].trim()) return parts[1].trim();
    var s = parts[0].trim().replace(/^\s*(free|gratis|gratuit|kostenlos)\s+/i, '');
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  
  function inSentence(s){
    s = String(s || '');
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang === 'de' || lang.indexOf('de-') === 0) return s;
    return s.charAt(0).toLowerCase() + s.slice(1);
  }
  
  function gcpSwPage(grid, dir){
    if (!grid || !grid.querySelector('.gcp-sw')) return 0;
    
    var one = grid.querySelector('.gcp-sw');
    var gap = parseFloat(getComputedStyle(grid).gap || 0);
    var step = (one ? one.offsetWidth : 44) + gap;
    var max  = grid.scrollWidth - grid.clientWidth;
    var to   = Math.max(0, Math.min(max, grid.scrollLeft + dir * step));
    
    grid.style.scrollBehavior = 'auto';
    grid.scrollLeft = to;
    return to;
  }
  
  var gcpSwLast = 0;
  
  var gcpRailLast = 0;
  function gcpRailKeep(){
    var r = document.querySelector('.gcp-rail');
    if (r) gcpRailLast = r.scrollLeft;
  }

  
  function restoreScroll(el, want, remember){
    el.style.scrollBehavior = 'auto';            // jump, never animate, on a fresh render
    var settling = want > 0;
    (function attempt(tries){
      if (!settling) return;
      el.scrollLeft = want;
      
      if (el.scrollLeft >= want - 1 || tries <= 0){ settling = false; return; }
      requestAnimationFrame(function(){ attempt(tries - 1); });
    })(10);
    
    el.addEventListener('scroll', function(){ if (!settling) remember(el.scrollLeft); },
      { passive: true });
  }

  
  var gcpSwObserver = null;
  function gcpSwWatch(){
    var modal = document.getElementById('gcp-modal');
    if (!modal || gcpSwObserver) return;
    gcpSwObserver = new MutationObserver(function(muts){
      for (var i = 0; i < muts.length; i++){
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++){
          var n = added[j];
          if (!n || n.nodeType !== 1) continue;
          var row = (n.classList && n.classList.contains('gcp-sw-grid'))
            ? n
            : (n.querySelector ? n.querySelector('.gcp-sw-grid') : null);
          if (!row) continue;
          var rail = row.closest('.gcp-sw-rail');
          if (rail) gcpSwArrows(rail);
          
          restoreScroll(row, gcpSwLast, function(v){
            gcpSwLast = v;
            if (rail) gcpSwArrows(rail);
          });
          return;
        }
      }
    });
    gcpSwObserver.observe(modal, { childList: true, subtree: true });
    
    setTimeout(function(){
      modal.querySelectorAll('.gcp-sw-grid').forEach(function(row){
        if (row.dataset.swBound) return;
        row.dataset.swBound = '1';
        var rail = row.closest('.gcp-sw-rail');
        row.addEventListener('scroll', function(){
          gcpSwLast = row.scrollLeft;
          if (rail) gcpSwArrows(rail);
        }, { passive: true });
      });
    }, 300);
  }


  
  function gcpSwArrows(rail){
    var grid = rail.querySelector('.gcp-sw-grid');
    var l = rail.querySelector('.gcp-sw-arw--l');
    var r = rail.querySelector('.gcp-sw-arw--r');
    if (!grid || !l || !r) return;
    var max = grid.scrollWidth - grid.clientWidth;
    l.hidden = grid.scrollLeft <= 1;
    r.hidden = grid.scrollLeft >= max - 1;
  }
  document.addEventListener('click', function(e){
    var nav = e.target.closest('[data-gc-sw-nav]');
    if (!nav) return;
    e.preventDefault();
    
    e.stopPropagation();
    var rail = nav.closest('.gcp-sw-rail');
    var row = rail.querySelector('.gcp-sw-grid');
    gcpSwPage(row, +nav.dataset.gcSwNav);
    
    gcpSwLast = row.scrollLeft;
    
    gcpSwArrows(rail);
  });
  
  document.addEventListener('scroll', function(e){
    var g = e.target;
    if (g && g.classList && g.classList.contains('gcp-sw-grid')){
      
      gcpSwLast = g.scrollLeft;
      gcpSwArrows(g.closest('.gcp-sw-rail'));
    }
  }, true);

  window.gcpSwatchFallback = function(el){
    var list = [];
    try { list = JSON.parse(el.getAttribute('data-sw') || '[]'); } catch(e){ list = []; }
    var i = (+el.getAttribute('data-i') || 0) + 1;
    if (i < list.length){                        // try the next candidate filename
      el.setAttribute('data-i', String(i));
      el.src = list[i];
      return;
    }
    
    var photo = el.getAttribute('data-photo') || '';
    el.classList.add('is-fallback');
    el.removeAttribute('src');
    if (photo && el.parentNode) el.parentNode.style.backgroundImage = 'url(' + photo + ')';  };

  var DECLINED_KEY = 'ntf_declined_gifts', PLACED_KEY = 'ntf_placed_gifts';
  
  var ntfGiftTok = null;
  function readSet(k){
    try {
      var o = JSON.parse(localStorage.getItem(k) || 'null');
      if (!o || Array.isArray(o)) return [];
      if (ntfGiftTok && o.t !== ntfGiftTok) return [];
      return (o.v || []).map(String);
    } catch(e){ return []; }
  }
  function writeSet(k, arr){
    try { localStorage.setItem(k, JSON.stringify({ t: ntfGiftTok, v: arr.map(String) })); } catch(e){}
  }
  function isDeclined(vid){ return readSet(DECLINED_KEY).indexOf(String(vid)) !== -1; }
  function decline(vid){
    var d = readSet(DECLINED_KEY);
    if (d.indexOf(String(vid)) === -1){ d.push(String(vid)); writeSet(DECLINED_KEY, d); }
  }
  function undecline(vid){
    writeSet(DECLINED_KEY, readSet(DECLINED_KEY).filter(function(x){ return x !== String(vid); }));
  }
  function markPlaced(vid){
    var p = readSet(PLACED_KEY);
    if (p.indexOf(String(vid)) === -1){ p.push(String(vid)); writeSet(PLACED_KEY, p); }
  }
  function wasPlaced(vid){ return readSet(PLACED_KEY).indexOf(String(vid)) !== -1; }
  /* K11 (27 Oct 2026): a gift add whose answer is lost because the page changed (a click away, a reload) still reaches
     Shopify. The memory used to be written only on the answer, so it was lost with it: a removed gift then read as
     "never placed" and came back, and a reload mid-add added a second gift line (charged at full price). The memory
     is now written BEFORE the add, undone if Shopify refuses it, and a gift sent in the last 15 s counts as on its
     way: not re-added, not read as removed. */
  var PENDING_KEY = 'ntf_gift_pending', PENDING_MS = 15000;
  function pendingMap(){ try { var o = JSON.parse(localStorage.getItem(PENDING_KEY) || '{}'); return (o && o.t === ntfGiftTok && o.v) || {}; } catch(e){ return {}; } }
  function setPending(vids, on){
    try { var m = pendingMap(), now = Date.now(); vids.forEach(function(v){ if (on) m[String(v)] = now; else delete m[String(v)]; });
      localStorage.setItem(PENDING_KEY, JSON.stringify({ t: ntfGiftTok, v: m })); } catch(e){}
  }
  function isPending(vid){ var t = pendingMap()[String(vid)]; return !!t && (Date.now() - t) < PENDING_MS; }
  function unmarkPlaced(vid){ writeSet(PLACED_KEY, readSet(PLACED_KEY).filter(function(x){ return x !== String(vid); })); }

  var _cartP = null, _cartAt = 0;
  function getCart(force){
    var now = (window.performance && performance.now) ? performance.now() : Date.now();
    if (!force && _cartP && (now - _cartAt) < 400) return _cartP;
    _cartAt = now;
    _cartP = fetch('/cart.js?_=' + Date.now(), { headers:{ Accept:'application/json' }, cache:'no-store' })
      .then(function(r){ return r.json(); })
      .catch(function(){ _cartP = null; return { items: [] }; });
    return _cartP;
  }
  function cartChanged(){ _cartP = null; }

  function getData(row){
    try {
      var d = JSON.parse(row.dataset.gc);
      tierCopy(d && d.tiers);
      return d;
    }
    catch(e){ return { tiers:[], gifts:[], limit:1 }; }
  }
  
  function payloadEl(){ return document.getElementById('gcp-modal'); }
  function isGiftLine(it){
    var p = (it && it.properties) || {};
    return !!(p._gift_choice || p._Gifted || p._auto_gift);
  }
  
  function cartBases(cart){
    var pre = cart.items_subtotal_price || 0, post = cart.total_price || 0;
    (cart.items || []).forEach(function(it){
      if (!isGiftLine(it)) return;
      pre -= (it.final_line_price || 0);
      post -= (it.line_price || 0);
    });
    pre = Math.max(0, pre); post = Math.max(0, post);
    return { pre: pre, post: post, orderDisc: Math.max(0, pre - post) };
  }
  function qualifyingTotal(cart){ return cartBases(cart).pre; }
  
  var NTF_AUTO_TYPES = ['Beaded Bracelet','Silver Ring','Silver Bracelet','Silver Bangle','Silver Chain','Silver Pendant','Jewellery Set'];
  function autoGiftEligible(cart, vid){
    return (cart.items || []).some(function(it){
      var p = it.properties || {};
      
      if (p._auto_gift || p._gift_choice || p._Gifted || !(it.final_line_price > 0)) return false;
      return NTF_AUTO_TYPES.indexOf(it.product_type) !== -1;
    });
  }
  
  function vFor(v, t){
    var od = (state && state.orderDisc) || 0;
    return (t && t.type === 'shipping') ? v : v + od;
  }
  function unlocked(v, t){ return vFor(v, t) >= t.th; }
  function nextIdx(v, T){ for (var i=0;i<T.length;i++){ if (!unlocked(v, T[i])) return i; } return -1; }
  function segPct(i, T, v){
    var prev = i===0 ? 0 : T[i-1].th;
    var span = T[i].th - prev; if (span<=0) span=1;
    return Math.max(0, Math.min(100, (vFor(v, T[i])-prev)/span*100));
  }
  function giftTierIdx(T){
    for (var i=0;i<T.length;i++){ if (T[i].type === 'gift_choice') return i; }
    return -1;
  }
  
  function giftOutstanding(v, T, chosen, limit){
    var gi = giftTierIdx(T);
    return gi !== -1 && unlocked(v, T[gi]) && chosen < (limit || 1);
  }

  
  function paintRow(row){
    var d = getData(row);
    var T = d.tiers || [];
    if (!T.length) return;
    var v = +row.dataset.value || 0;
    var chosen = +row.dataset.chosen || 0;
    var ni = nextIdx(v, T);
    var gi = giftTierIdx(T);

    
    var claimable = giftOutstanding(v, T, chosen, d.limit);
    row.classList.toggle('is-claim', claimable);
    if (claimable){ paintBanner(row, d, T, gi); return; }

    var thumbEl = row.querySelector('.gcr-thumb');
    var headEl = row.querySelector('.gcr-headline');
    var chipsEl = row.querySelector('.gcr-chips');
    if (!thumbEl || !headEl || !chipsEl) return;

    
    var focus = giftOutstanding(v, T, chosen, d.limit) ? T[gi] : (ni === -1 ? T[T.length-1] : T[ni]);
    if (focus.img){
      thumbEl.style.backgroundImage = 'url(' + focus.img + ')';
      thumbEl.textContent = '';
      thumbEl.classList.remove('gcr-thumb--badge');
    } else {
      thumbEl.style.backgroundImage = '';
      thumbEl.textContent = shortLabel(focus.label);
      thumbEl.classList.add('gcr-thumb--badge');
    }

    var head;
    if (giftOutstanding(v, T, chosen, d.limit)){
      head = '<b>' + esc(TX('choose-your-free-gift', null, 'Choose your free gift')) + '</b> \u2014 ' + esc(TX('unlocked-suffix', null, 'unlocked'));
    } else if (ni === -1){
      head = '<b>' + esc(TX('all-rewards-unlocked', null, 'All rewards unlocked')) + '</b> &#10003;';
    } else {
      head = TXH('spend-more-for', { amount: '<b>' + fmt(T[ni].th - vFor(v, T[ni])) + '</b>', reward: esc(shortLabel(T[ni].label)) },
        'Spend <b>' + fmt(T[ni].th - vFor(v, T[ni])) + '</b> more for ' + esc(shortLabel(T[ni].label)));
    }
    if (headEl.innerHTML !== head) headEl.innerHTML = head;

    var c = '';
    T.forEach(function(t, i){
      var on = unlocked(v, t);
      var todo = (i === gi) && on && chosen < (d.limit || 1);
      var cls = 'gcr-chip' + (todo ? ' is-todo' : (on ? ' is-on' : (i === ni ? ' is-next' : '')));
      
      var gone = on && t.type === 'auto_gift' && t.autoVid && isDeclined(t.autoVid);
      var badge = gone ? '+' : (todo ? '&#9733;' : (on ? '&#10003;' : ''));
      if (gone) cls += ' is-gone';
      
      var giftChip = t.type === 'gift_choice' ? (on ? 'open' : 'locked') : '';
      c += '<span class="' + cls + '" data-gc-fill="' + segPct(i, T, v) + '"'
        + (giftChip ? ' data-gc-giftchip="' + giftChip + '" title="' + esc(TX('see-the-rewards', null, 'See the rewards')) + '"' : '')
        + (gone ? ' data-gc-readd="' + t.autoVid + '" title="' + esc(TX('add-it-back', null, 'Add it back')) + '"' : '') + '>'
        + '<i class="gcr-chip-fill" style="width:0"></i>'
        + (badge ? '<span class="gcr-chip-d">' + badge + '</span>' : '')
        + '<span class="gcr-chip-l">' + esc(shortLabel(t.label)) + '</span>'
      + '</span>';
    });
    
    var sig = v + "|" + chosen + "|" + ni + "|" + T.map(function(t){ return t.th; }).join(",");
    if (chipsEl.dataset.gcSig !== sig){
      chipsEl.dataset.gcSig = sig;
      chipsEl.innerHTML = c;
      requestAnimationFrame(function(){
        chipsEl.querySelectorAll('[data-gc-fill]').forEach(function(chip){
          var f = chip.querySelector('.gcr-chip-fill');
          if (f) f.style.width = chip.dataset.gcFill + '%';
        });
      });
    }
  }
  
  function poolTopWorth(d){
    var max = 0;
    (d.gifts || []).forEach(function(g){ if (+g.price > max) max = +g.price; });
    if (d.bundle && d.bundle.items){
      d.bundle.items.forEach(function(i){ if (+i.price > max) max = +i.price; });
    }
    return max;
  }

  
  function paintBanner(row, d, T, gi){
    var el = row.querySelector('.gcr-banner');
    if (!el) return;
    var t = T[gi];
    var top = poolTopWorth(d);
    var worthPhrase = top ? ' ' + fmtRound(top) : '';
    var sig = 'claim|' + t.th + '|' + top;
    if (el.dataset.gcSig === sig) return;
    el.dataset.gcSig = sig;
    
    el.innerHTML =
      '<div class="gcr-band">'
      + '<span class="gcr-band-t">' + esc(TX('earned-free-bracelet', null, 'You\u2019ve earned a free bracelet.')) + '</span>'
      + '<span class="gcr-band-cta">' + esc(TX('choose-now', null, 'Choose now')) + '</span>'
      + '</div>';
  }

  
  function refreshCartVids(){
    return getCart().then(function(cart){
      state && (state.cartVids = {});
      (cart.items || []).forEach(function(it){ if (state) state.cartVids[it.variant_id] = true; });
      return cart;
    }).catch(function(){ return null; });
  }
  function scanRows(){ document.querySelectorAll('[data-gc-row]').forEach(paintRow); }

  
  function openPickerStandalone(e){
    
    if (!(e && e.detail && e.detail.open)){
      
      setTimeout(function(){ document.dispatchEvent(new CustomEvent('ntf:open-rewards-popup', { detail:{ fromList: true } })); }, 0);
      return;
    }
    
    var preview = !!(e && e.detail && e.detail.preview);
    
    var from = (e && e.detail && e.detail.from) || '';
    gcpSwLast = 0;                      // a newly opened picker starts at the first swatch
    gcpRailLast = 0;                    // ...and at the first reward
    gcpSwWatch();

    var m = document.getElementById('gcp-modal');
    if (!m) return;
    var d;
    try { d = JSON.parse(m.getAttribute('data-gc') || '{}'); } catch(e){ return; }
    getCart(true).then(function(cart){
      var chosen = 0;
      (cart.items || []).forEach(function(it){
        if (it.properties && it.properties._gift_choice) chosen += it.quantity;
      });
      var bases = cartBases(cart);
      var fake = document.createElement('div');
      fake.setAttribute('data-gc', m.getAttribute('data-gc'));
      fake.dataset.value = bases.post;
      fake.dataset.orderDisc = bases.orderDisc;
      fake.dataset.chosen = chosen;
      fake.dataset.preview = preview ? '1' : '';
      fake.dataset.from = from;
      
      fake.dataset.open = (e && e.detail && e.detail.open) || '';
      openPopup(fake);
    });
  }
  document.addEventListener('ntf:open-gift-picker', openPickerStandalone);

  function openPopup(row){
    var d = getData(row);
    state = {
      T: d.tiers || [],
      
      gifts: (d.gifts || []).map(function(g){
        var c = {}; for (var k in g) c[k] = g[k];
        c.title = String(g.title || '').replace(/\s*[-–]\s*(free|gratis|kostenlos|gratuit)\s*$/i, '');
        return c;
      }),
      bundle: d.bundle || null,
      bColour: null,
      bSize: null,
      limit: d.limit || 1,
      value: +row.dataset.value || 0,
      chosen: +row.dataset.chosen || 0,
      picked: null,
      orderDisc: +row.dataset.orderDisc || 0,
      marker: (d && d.marker) || '',
      busy: false,
      preview: row.dataset.preview === '1',
      fromRewards: row.dataset.from === 'rewards',
      dvid: (row.dataset.open && row.dataset.open !== 'bundle') ? +row.dataset.open : 0,
      di: 0,
      bOpen: row.dataset.open === 'bundle'
    };
    
    state.cartVids = {};
    getCart()
      .then(function(cart){
        (cart.items || []).forEach(function(it){
          state.cartVids[it.variant_id] = true;
          if (it.properties && it.properties._gift_choice) state.picked = it.variant_id;
        });
        paintModal();
        
        setTimeout(warmColours, 600);
      })
      .catch(function(){});
    paintModal();
    var m = document.getElementById('gcp-modal');
    document.body.appendChild(m);              // last in DOM order — the drawer overlay cannot cover it
    
    var gcpWasOpen = m.style.display === 'flex';
    m.style.display = 'flex';
    if (!gcpWasOpen){ m.classList.remove('ntf-pop-in'); void m.offsetWidth; m.classList.add('ntf-pop-in'); }
    m.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closePopup(){
    var m = document.getElementById('gcp-modal');
    if (!m) return;
    m.style.display = 'none';
    m.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  
  function paintWon(T){
    var vids = (state && state.cartVids) || {};
    var missing = 0;
    
    var items = T.map(function(t){
      
      var inCart;
      if (t.type === 'auto_gift')        inCart = !!(t.autoVid && vids[t.autoVid]);
      else if (t.type === 'gift_choice') inCart = (state.chosen || 0) > 0;
      else                               inCart = true;   // a discount has no cart line

      var extra = '', cls = '';
      if (!inCart){
        missing++;
        cls = ' is-pending';
        extra = (t.type === 'auto_gift')
          ? '<button type="button" class="gcp-readd" data-gc-readd="' + t.autoVid + '">' + esc(TX('add-it-back', null, 'Add it back')) + '</button>'
          : '<button type="button" class="gcp-readd" data-gc-choose>' + esc(TX('choose-yours', null, 'Choose yours')) + '</button>';
      }
      
      var name = (t.type === 'gift_choice' && inCart && state.bColour) ? state.bColour : shortLabel(t.label);

      return '<div class="cr-band-cell' + cls + '">'
        + '<span class="cr-band-top">'
          + '<i class="cr-band-tick" aria-hidden="true">' + (inCart ? '&#10003;' : '!') + '</i>'
          + '<span class="cr-band-th">' + fmtRound(t.th) + '</span>'
        + '</span>'
        + '<span class="cr-band-nm">' + esc(name) + '</span>'
        + (extra ? '<span class="cr-band-sm">' + extra + '</span>' : '')
      + '</div>';
    }).join('');

    
    var sub = missing
      ? esc(TX('choose-before-checkout', null, 'Choose your reward before you check out'))
      : esc(TX('gifts-already-in-cart', null, 'Your gifts are already in the cart'));

    return '<div class="cr-won">'
      + '<div class="cr-won-head">'
        + '<span class="cr-won-hrow">'
          + '<span class="cr-won-h">' + esc(TX('unlocked-all-n-rewards', { n: T.length },
                'All ' + T.length + ' rewards unlocked')) + '</span>'
        + '</span>'
        + '<span class="cr-won-sub">' + sub + '</span>'
      + '</div>'
      + '<div class="cr-wonband">' + items + '</div>'
      + '<a class="cr-cta cr-won-cta" href="/checkout">' + esc(TX('proceed-to-checkout', null, 'Proceed to checkout')) + '</a>'
    + '</div>';
  }

  function paintModal(){
    if (!state) return;
    var T = state.T, v = state.value;
    var ni = nextIdx(v, T), gi = giftTierIdx(T);

    
    var dlg = document.querySelector('.gcp-dialog');
    
    var picking = gi !== -1 && unlocked(v, T[gi]) && giftOutstanding(v, T, state.chosen, state.limit);
    
    if (state.preview) picking = true;
    var won = ni === -1 && !picking;
    if (dlg){
      dlg.classList.toggle('is-picking', !!picking);
      dlg.classList.toggle('is-won', !!won);
      
      dlg.classList.toggle('is-wide', (state.preview || (gi !== -1 && unlocked(v, T[gi]))) && !won);
      
      dlg.classList.toggle('is-detail', !!(state.dvid || state.bOpen));
    }
    if (won){
      var ladderEl = document.getElementById('gcp-ladder');
      if (ladderEl) ladderEl.innerHTML = paintWon(T);
      var giftsEl = document.getElementById('gcp-gifts');
      if (giftsEl) giftsEl.hidden = true;
      var footEl = document.getElementById('gcp-foot');
      if (footEl) footEl.innerHTML = '';
      return;   // the won view is the whole panel
    }

    var sub = document.getElementById('gcp-sub');
    
    var titleEl = document.getElementById('gcp-title');
    var pickLast = ni === -1 && giftOutstanding(v, T, state.chosen, state.limit);
    
    var gcpCampaign = '';
    var gcpModalEl = document.getElementById('gcp-modal');
    if (gcpModalEl) gcpCampaign = (gcpModalEl.getAttribute('data-gc-campaign') || '').trim();
    if (titleEl) titleEl.textContent = gcpCampaign || (pickLast
      ? TX('unlocked-all-rewards', null, 'You’ve unlocked all rewards')
      : TX('your-rewards', null, 'Your rewards'));
    if (pickLast){
      sub.innerHTML = TXH('choose-your-x', { gift: '<b>' + esc(TX('free-gift-word', null, 'free gift')) + '</b>' },
        'Choose your <b>' + esc(TX('free-gift-word', null, 'free gift')) + '</b>');
    } else if (giftOutstanding(v, T, state.chosen, state.limit)){
      
      var giftWord = TX('gc-reward-word', null, 'reward');
      sub.innerHTML = TXH('choose-your-x', { gift: '<b>' + esc(giftWord) + '</b>' },
        'Choose your <b>' + esc(giftWord) + '</b>');
    } else if (state.preview && gi !== -1){
      
      sub.innerHTML = TXH('spend-more-for-sentence',
        { amount: '<b>' + fmt(T[gi].th - vFor(v, T[gi])) + '</b>', reward: esc(inSentence(shortLabel(T[gi].label))) },
        'Spend <b>' + fmt(T[gi].th - vFor(v, T[gi])) + '</b> more for ' + esc(inSentence(shortLabel(T[gi].label))) + '.');
    } else if (ni === -1){
      sub.innerHTML = esc(TX('all-rewards-unlocked', null, 'All rewards unlocked')) + ' &#10003;';
    } else {
      sub.innerHTML = TXH('spend-more-for-sentence',
        { amount: '<b>' + fmt(T[ni].th - vFor(v, T[ni])) + '</b>', reward: esc(inSentence(shortLabel(T[ni].label))) },
        'Spend <b>' + fmt(T[ni].th - vFor(v, T[ni])) + '</b> more for ' + esc(inSentence(shortLabel(T[ni].label))) + '.');
    }

    
    if (state.openTier == null) state.openTier = (ni === -1 ? T.length - 1 : ni);
    var h = '';
    T.forEach(function(t, i){
      var on = unlocked(v, t);
      var isNext = (i === ni);
      var open = (state.openTier === i);
      var mediaAttr = t.img ? (' style="background-image:url(' + t.img + ')"') : '';
      var mediaCls = 'cr-media' + (t.img ? '' : ' cr-media--badge');
      var pct = 0;
      if (isNext){
        var prevTh = i === 0 ? 0 : T[i-1].th;
        var span = t.th - prevTh; if (span <= 0) span = 1;
        pct = Math.max(0, Math.min(100, (vFor(v, t) - prevTh) / span * 100));
      }
      var status;
      if (i === gi && on && state.chosen < (state.limit || 1)){
        status = '<span class="cr-status is-todo"><span class="cr-tick">&#9733;</span> ' + esc(TX('ready-to-choose', null, 'Ready to choose')) + '</span>';
      } else if (on){
        status = '<span class="cr-status is-done"><span class="cr-tick">&#10003;</span> ' + esc(TX('unlocked', null, 'Unlocked')) + '</span>';
      } else {
        status = '<span class="cr-status is-todo">' + esc(TX('to-go', { amount: fmt(t.th - vFor(v, t)) }, fmt(t.th - vFor(v, t)) + ' to go')) + '</span>';
      }
      h += '<li class="cr-tier' + (on ? ' done' : '') + (isNext ? ' next' : '')
          + (open ? ' is-open' : ' is-collapsed') + '">'
        + '<div class="cr-step">' + (on ? '&#10003;' : (i+1)) + '</div>'
        + '<button type="button" class="cr-card" data-gc-tier="' + i + '"'
          + ' aria-expanded="' + (open ? 'true' : 'false') + '">'
          + '<span class="' + mediaCls + '"' + mediaAttr + '>' + (t.img ? '' : esc(shortLabel(t.label))) + '</span>'
          + '<span class="cr-info">'
            + '<span class="cr-th">' + esc(TX('tier-n-spend', { n: i + 1, amount: fmt(t.th) },
                'Tier ' + (i+1) + ' · Spend ' + fmt(t.th))) + '</span>'
            + '<span class="cr-lb">' + esc(fullLabel(t.label)) + '</span>'
            + (open && t.desc ? '<span class="cr-desc">' + esc(t.desc) + '</span>' : '')
            + status
            + (isNext ? '<span class="cr-nextbar"><i style="width:' + pct + '%"></i></span>' : '')
          + '</span>'
          + '<span class="cr-toggle" aria-hidden="true">&#9662;</span>'
        + '</button>'
      + '</li>';
    });
    document.getElementById('gcp-ladder').innerHTML = h;

    paintGifts(gi);
    document.getElementById('gcp-foot').innerHTML = (ni === -1)
      ? '<a class="gcp-cta" href="/checkout">' + esc(TX('proceed-to-checkout', null, 'Proceed to checkout')) + '</a>'
      
      : '<a class="gcp-cta" href="' + shopUrl() + '">'
          + esc(TX('add-more-for', { amount: fmt(T[ni].th - vFor(v, T[ni])), reward: inSentence(shortLabel(T[ni].label)) },
                   'Add ' + fmt(T[ni].th - vFor(v, T[ni])) + ' more for ' + inSentence(shortLabel(T[ni].label))))
          + '</a>'
        + '<button type="button" class="gcp-cta gcp-cta--ghost" data-gc-close>' + esc(TX('back-to-cart', null, 'Back to cart')) + '</button>';
  }

  
  function shopUrl(){
    return (window.NTF_CART_CONFIG && window.NTF_CART_CONFIG.continueShopping) || '/collections/all';
  }

  
  function lockedCta(t){
    return TX('spend-more-to-unlock-short', { amount: fmt(t.th - vFor(state.value, t)) },
             'Spend ' + fmt(t.th - vFor(state.value, t)) + ' more to unlock');
  }

  
  function gcpStep(d){
    var n = currentGallery().length || 1;
    state.di = ((state.di || 0) + d + n) % n;
    paintModal();
  }
  
  var gcpSx = null, gcpSy = 0;
  document.addEventListener('touchstart', function(e){
    gcpSx = (e.target.closest && e.target.closest('.gcp-split .gcp-hero') && e.touches.length === 1)
      ? e.touches[0].clientX : null;
    if (gcpSx !== null) gcpSy = e.touches[0].clientY;
  }, { passive:true });
  document.addEventListener('touchend', function(e){
    if (gcpSx === null || !state) return;
    var t = e.changedTouches[0], dx = t.clientX - gcpSx, dy = t.clientY - gcpSy;
    gcpSx = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) && currentGallery().length > 1){
      if (e.cancelable) e.preventDefault();   // no tap-to-step on top of the swipe
      gcpStep(dx < 0 ? 1 : -1);
    }
  });
  function currentGallery(){
    if (!state) return [];
    if (state.dvid){
      var g = state.gifts.filter(function(x){ return x.vid === state.dvid; })[0];
      return g ? ((g.imgs && g.imgs.length) ? g.imgs : (g.img ? [g.img] : [])) : [];
    }
    if (state.bOpen && state.bundle && state.bundle.items){
      var its = state.bundle.items.filter(function(it){ return it.colour === state.bColour; });
      var it = its.filter(function(x){ return x.size === state.bSize; })[0] || its[0];
      if (!it) return [];
      return (it.imgs && it.imgs.length) ? it.imgs : (it.img ? [it.img] : []);
    }
    return [];
  }

  
  var warmed = {}, warmQ = [], warmN = 0;
  function warmPump(){
    while (warmN < 6 && warmQ.length){
      var u = warmQ.shift();
      if (warmed[u]) continue;
      warmed[u] = 1; warmN++;
      var im = new Image();
      im.onload = im.onerror = function(){ warmN--; warmPump(); };
      im.src = u;
    }
  }
  function warmUrls(urls, first){
    var add = (urls || []).filter(function(u){ return u && !warmed[u]; });
    if (!add.length) return;
    warmQ = first ? add.concat(warmQ) : warmQ.concat(add);
    warmPump();
  }
  
  function thumbUrl(u){
    u = String(u || '');
    return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=180')
      : u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=180';
  }
  var gcpLastHero = '';
  function colourPhotos(colour, size){
    var its = state.bundle.items.filter(function(it){ return it.colour === colour; });
    var it = its.filter(function(x){ return x.size === size; })[0] || its[0];
    return it ? ((it.imgs && it.imgs.length) ? it.imgs : (it.img ? [it.img] : [])) : [];
  }
  function warmColours(first){
    if (!state || !state.bundle || !state.bundle.items) return;
    var others = (state.bundle.sizes || []).filter(function(sz){ return sz !== state.bSize; });
    var seen = {}, colours = [], urls = [];
    state.bundle.items.forEach(function(it){ if (!seen[it.colour]){ seen[it.colour] = 1; colours.push(it.colour); } });
    
    colours.forEach(function(c){ var ph = colourPhotos(c, state.bSize); if (ph[0]) urls.push(ph[0]); });
    others.forEach(function(sz){ colours.forEach(function(c){ var ph = colourPhotos(c, sz); if (ph[0]) urls.push(ph[0]); }); });
    colours.forEach(function(c){ colourPhotos(c, state.bSize).forEach(function(u){ urls.push(thumbUrl(u)); }); });
    warmUrls(urls, first);
  }
  
  function warmColour(colour, first){
    if (!state || !state.bundle || !state.bundle.items || !colour) return;
    var ph = colourPhotos(colour, state.bSize);
    warmUrls(ph.slice(0, 1).concat(ph.map(thumbUrl)).concat(ph.slice(1)), first);
  }
  function warmFromEvent(e){
    var sw = e.target && e.target.closest && e.target.closest('#gcp-modal [data-gc-colour]');
    if (sw && state) warmColour(sw.dataset.gcColour, true);
  }
  document.addEventListener('pointerover', warmFromEvent, { passive: true });
  document.addEventListener('touchstart', warmFromEvent, { passive: true });
  document.addEventListener('focusin', warmFromEvent);

  function paintGifts(gi){
    var wrap = document.getElementById('gcp-gifts');
    var grid = document.getElementById('gcp-grid');
    var head = document.getElementById('gcp-gifts-h');
    if (!wrap || !grid) return;
    var hasBundle = !!(state.bundle && state.bundle.items && state.bundle.items.length);
    if (gi === -1 || (!state.gifts.length && !hasBundle)){ wrap.hidden = true; return; }
    wrap.hidden = false;

    var t = state.T[gi];
    
    var open = unlocked(state.value, t) || state.preview;
    if (!open){
      head.textContent = TX('your-gift-at', { amount: fmtRound(t.th) }, 'Your gift, at ' + fmtRound(t.th));

      grid.innerHTML = '<div class="gcp-locked">'
        + esc(TX('gc-spend-more-to-choose', { amount: fmt(t.th - vFor(state.value, t)) },
            'Spend ' + fmt(t.th - vFor(state.value, t)) + ' more to choose one of these free.'))
        + '</div>';
      return;
    }
    head.textContent = state.preview
      ? TX('your-rewards-at', { amount: fmtRound(t.th) }, 'Your rewards at ' + fmtRound(t.th))
      : (state.chosen >= state.limit ? TX('your-gift', null, 'Your gift') : TX('choose-your-gift', null, 'Choose your gift'));

    
    var bundleHtml = '';
    if (state.bOpen && state.bundle && state.bundle.items && state.bundle.items.length){
      var b = state.bundle;
      
      var colours = [];
      b.items.forEach(function(it){
        var c = colours.filter(function(x){ return x.colour === it.colour; })[0];
        if (!c){ c = { colour: it.colour, img: it.img, sw: it.sw || [], slug: it.slug, rank: (it.rank == null ? 99 : it.rank), nAvail: 0, nTotal: 0 }; colours.push(c); }
        c.nTotal++;
        if (it.avail !== false) { c.nAvail++; if (!c.imgAvail) c.imgAvail = it.img; }
      });
      
      colours.sort(function(a, b){ return (a.rank - b.rank) || a.colour.localeCompare(b.colour); });
      colours.forEach(function(c){
        c.soldOut = c.nAvail === 0;
        c.partial = c.nAvail > 0 && c.nAvail < c.nTotal;
        if (c.imgAvail) c.img = c.imgAvail;
      });
      
      var firstOk = colours.filter(function(c){ return !c.soldOut; })[0];
      var curC = colours.filter(function(c){ return c.colour === state.bColour; })[0];
      if ((!curC || curC.soldOut) && firstOk) state.bColour = firstOk.colour;
      if (state.bColour == null) state.bColour = colours[0].colour;
      
      var forColour = b.items.filter(function(it){ return it.colour === state.bColour; });
      var have = forColour.filter(function(it){ return it.avail !== false; }).map(function(it){ return it.size; });
      if (have.indexOf(state.bSize) === -1) state.bSize = have[0];
      var match = forColour.filter(function(it){ return it.size === state.bSize && it.avail !== false; })[0];
      var pickedHere = match && state.picked === match.vid;
      
      var sizedItem = b.items.filter(function(it){
        return it.colour === state.bColour && it.size === state.bSize;
      })[0];
      var heroImg = (sizedItem && sizedItem.img)
        || (colours.filter(function(c){ return c.colour === state.bColour; })[0] || {}).img
        || b.img;
      
      var bGal = currentGallery();
      if (!bGal.length && heroImg) bGal = [heroImg];
      var bdi = Math.max(0, Math.min(state.di || 0, bGal.length - 1));
      if (bGal.length) heroImg = bGal[bdi];
      
      var bNavL = bGal.length > 1
        ? '<button type="button" class="gcp-dnav gcp-dnav--l" data-gc-dnav="-1" aria-label="' + esc(TX('prev-image', null, 'Previous image')) + '">&lsaquo;</button>'
        : '';
      var bNavR = bGal.length > 1
        ? '<button type="button" class="gcp-dnav gcp-dnav--r" data-gc-dnav="1" aria-label="' + esc(TX('next-image', null, 'Next image')) + '">&rsaquo;</button>'
        : '';
      var bThumbs = bGal.length > 1
        ? '<div class="gcp-thumbrow">' + bNavL + '<div class="gcp-thumbs">' + bGal.map(function(u, i){
            return '<button type="button" class="gcp-thumb' + (i === bdi ? ' is-on' : '') + '"'
              + ' data-gc-dimg="' + i + '" aria-label="' + esc(TX('gc-image-n', { n: i + 1 }, 'Image ' + (i + 1))) + '"'
              + ' style="background-image:url(' + thumbUrl(u) + ')"></button>';
          }).join('') + '</div>' + bNavR + '</div>'
        : '';

      
      var curColour = colours.filter(function(c){ return c.colour === state.bColour; })[0] || colours[0] || {};
      function stockNote(c){
        return c.soldOut ? '<span class="gcp-cs-note is-out">' + esc(TX('sold-out', null, 'Sold out')) + '</span>'
             : (c.partial ? '<span class="gcp-cs-note">' + esc(TX('few-left', null, 'Few left')) + '</span>' : '');
      }

      
      var swatches = '<div class="gcp-sw-head">'
          + '<span class="gcp-sw-lbl">' + esc(TX('colour', null, 'Colour')) + '</span>'
          + '<span class="gcp-sw-cur">' + esc(curColour.colour || '') + '</span>'
          + stockNote(curColour)
        + '</div>'
        + '<div class="gcp-sw-rail">'
          + '<button type="button" class="gcp-sw-arw gcp-sw-arw--l" data-gc-sw-nav="-1"'
            + ' aria-label="' + esc(TX('prev-colours', null, 'Previous colours')) + '" hidden>&lsaquo;</button>'
          + '<div class="gcp-sw-grid" role="radiogroup" aria-label="' + esc(TX('choose-a-colour', null, 'Choose a colour')) + '">'
        + colours.map(function(c){
            var on = c.colour === state.bColour;
            var cls = 'gcp-sw' + (on ? ' is-on' : '') + (c.soldOut ? ' is-out' : '');
            
            var img = '<img class="gcp-sw-img" src="' + ((c.sw && c.sw[0]) || '') + '"'
              + ' data-sw="' + esc(JSON.stringify(c.sw || [])) + '"'
              + ' data-i="0"'
              + ' data-photo="' + (c.img || '') + '"'
              + ' alt="" loading="eager" onerror="gcpSwatchFallback(this)">';
            return '<button type="button" role="radio" class="' + cls + '"'
              + ' aria-checked="' + (on ? 'true' : 'false') + '"'
              + ' title="' + esc(c.colour) + (c.soldOut ? ' \u2014 ' + esc(TX('sold-out-suffix', null, 'sold out')) : '') + '"'
              + ' aria-label="' + esc(c.colour) + (c.soldOut ? ', ' + esc(TX('sold-out-suffix', null, 'sold out')) : '') + '"'
              + (c.soldOut ? ' disabled' : ' data-gc-colour="' + esc(c.colour) + '"')
              + '>' + img + '</button>';
          }).join('')
          + '</div>'
          + '<button type="button" class="gcp-sw-arw gcp-sw-arw--r" data-gc-sw-nav="1"'
            + ' aria-label="' + esc(TX('more-colours', null, 'More colours')) + '">&rsaquo;</button>'
        + '</div>';

      
      var goneSizes = forColour.filter(function(it){ return it.avail === false; })
                               .map(function(it){ return it.size; });
      var sizes = b.sizes.map(function(s2){
        var avail = have.indexOf(s2) !== -1;
        return '<button type="button" class="gcp-size' + (s2 === state.bSize ? ' is-on' : '') + '"'
          + ' data-gc-size="' + esc(s2) + '"' + (avail ? '' : ' disabled') + '>' + esc(s2) + '</button>';
      }).join('');

      var priceHtml = match
        ? '<div class="gcp-pprice"><s>' + fmt(match.price) + '</s><b>' + esc(TX('free-badge', null, 'FREE')) + '</b></div>'
        : '<div class="gcp-pprice"><b>' + esc(TX('free-badge', null, 'FREE')) + '</b></div>';

      
      var backHtml = '<button type="button" class="gcp-cta gcp-cta--ghost" data-gc-back>' + esc(TX('go-back', null, 'Go back')) + '</button>';
      var ctaHtml = state.preview
        ? '<button type="button" class="gcp-cta gcp-cta--locked" data-gc-explore>' + lockedCta(t) + '</button>'
        : (match
        ? '<button type="button" class="gcp-cta' + (pickedHere ? ' is-done' : '') + '"'
            + ' data-gc-pick="' + match.vid + '"' + (state.busy ? ' disabled' : '') + '>'
            + (pickedHere ? esc(TX('added-to-order', null, 'ADDED TO YOUR ORDER')) + ' &#10003;'
                            : esc(TX('add-free-bracelet', null, 'ADD FREE BRACELET'))) + '</button>'
        : '<button type="button" class="gcp-cta" disabled>' + esc(TX('not-available', null, 'NOT AVAILABLE')) + '</button>');

      bundleHtml = '<div class="gcp-split gcp-split--bundle">'
        + '<div class="gcp-gal">'
          
          + '<div class="gcp-dhero"><div class="gcp-hero" style="background-image:url(' + heroImg + ')'
            + (gcpLastHero && gcpLastHero !== heroImg ? ', url(' + gcpLastHero + ')' : '') + '"></div></div>'
          + bThumbs
        + '</div>'
        + '<div class="gcp-info">'
          + '<h3 class="gcp-ptitle">' + esc(state.bColour || b.title) + '</h3>'
          + priceHtml
          
          + swatches
          + '<div class="gcp-orow gcp-orow--size"><b>' + esc(TX('size', null, 'Size')) + '</b></div>'
          + '<div class="gcp-sizes">' + sizes + '</div>'
          + backHtml
          + ctaHtml
        + '</div>'
      + '</div>';
      gcpLastHero = heroImg;
    }

    
    var detail = state.dvid ? state.gifts.filter(function(g){ return g.vid === state.dvid; })[0] : null;
    if (detail){
      var imgs = (detail.imgs && detail.imgs.length) ? detail.imgs : [detail.img];
      var di = Math.max(0, Math.min(state.di || 0, imgs.length - 1));
      var dPicked = state.picked === detail.vid;
      
      var thumbs = imgs.length > 1
        ? '<div class="gcp-thumbrow">'
          + '<button type="button" class="gcp-dnav gcp-dnav--l" data-gc-dnav="-1" aria-label="' + esc(TX('prev-image', null, 'Previous image')) + '">&lsaquo;</button>'
          + '<div class="gcp-thumbs">' + imgs.map(function(u, i){
            return '<button type="button" class="gcp-thumb' + (i === di ? ' is-on' : '') + '"'
              + ' data-gc-dimg="' + i + '" aria-label="' + esc(TX('gc-image-n', { n: i + 1 }, 'Image ' + (i + 1))) + '"'
              + ' style="background-image:url(' + thumbUrl(u) + ')"></button>';
          }).join('') + '</div>'
          + '<button type="button" class="gcp-dnav gcp-dnav--r" data-gc-dnav="1" aria-label="' + esc(TX('next-image', null, 'Next image')) + '">&rsaquo;</button>'
        + '</div>'
        : '';
      grid.innerHTML = '<button type="button" class="gcp-back" data-gc-back>&lsaquo; ' + esc(TX('all-rewards-back', null, 'All rewards')) + '</button>'
        + '<div class="gcp-split">'
          + '<div class="gcp-gal">'
            + '<div class="gcp-dhero"><div class="gcp-hero" style="background-image:url(' + imgs[di] + ')"></div></div>'
            + thumbs
          + '</div>'
          + '<div class="gcp-info">'
            + '<h3 class="gcp-ptitle">' + esc(detail.title) + '</h3>'
            + '<div class="gcp-pprice"><s>' + fmt(detail.price) + '</s><b>' + esc(TX('free-badge', null, 'FREE')) + '</b></div>'
            + descBlock(detail)
            
            + '<button type="button" class="gcp-cta gcp-cta--ghost" data-gc-back>' + esc(TX('go-back', null, 'Go back')) + '</button>'
            + (state.preview
              ? '<button type="button" class="gcp-cta gcp-cta--locked" data-gc-explore>' + lockedCta(t) + '</button>'
              : '<button type="button" class="gcp-cta' + (dPicked ? ' is-done' : '') + '"'
                + ' data-gc-pick="' + detail.vid + '"' + (state.busy ? ' disabled' : '') + '>'
                + (dPicked ? esc(TX('added-to-order', null, 'ADDED TO YOUR ORDER')) + ' &#10003;'
                             : esc(TX('choose-this-gift', null, 'CHOOSE THIS GIFT'))) + '</button>')
          + '</div>'
        + '</div>';
    } else if (state.bOpen && bundleHtml){
      
      grid.innerHTML = '<button type="button" class="gcp-back" data-gc-back>&lsaquo; ' + esc(TX('all-rewards-back', null, 'All rewards')) + '</button>'
                     + bundleHtml;
    } else {
      
      var cards = '';
      if (hasBundle){
        var bb = state.bundle;
        var bPicked = bb.items.some(function(it){ return it.vid === state.picked; });
        var bImg = (bb.items[0] && bb.items[0].img) || bb.img || '';
        var bPrice = bb.items[0] && bb.items[0].price;
        cards += '<div class="gcp-gift' + (bPicked ? ' is-picked' : '') + '" data-gc-bundle>'
          + '<span class="gcp-gift-img" style="background-image:url(' + bImg + ')"></span>'
          + '<div class="gcp-gift-b">'
            + '<div class="gcp-gift-t">' + esc(bb.title || TX('bundle-fallback-title', null, 'Beaded bracelet')) + '</div>'
            + '<div class="gcp-gift-p">' + (bPrice ? '<s>' + fmt(bPrice) + '</s>' : '') + esc(TX('free', null, 'Free')) + '</div>'
            + '<button type="button" class="gcp-pick" data-gc-bundle>'
              + (bPicked ? esc(TX('chosen', null, 'Chosen')) + ' &#10003;' : esc(TX('view', null, 'View'))) + '</button>'
          + '</div>'
        + '</div>';
      }
      cards += state.gifts.map(function(g){
        var picked = state.picked === g.vid;
        
        return '<div class="gcp-gift' + (picked ? ' is-picked' : '') + '" data-gc-view="' + g.vid + '">'
          + '<span class="gcp-gift-img" style="background-image:url(' + g.img + ')"></span>'
          + '<div class="gcp-gift-b">'
            + '<div class="gcp-gift-t">' + esc(g.title) + '</div>'
            + '<div class="gcp-gift-p"><s>' + fmt(g.price) + '</s>' + esc(TX('free', null, 'Free')) + '</div>'
            + '<button type="button" class="gcp-pick" data-gc-view="' + g.vid + '">'
              + (picked ? esc(TX('chosen', null, 'Chosen')) + ' &#10003;' : esc(TX('view', null, 'View'))) + '</button>'
          + '</div>'
        + '</div>';
      }).join('');
      grid.innerHTML = '<div class="gcp-rail">' + cards + '</div>'
        
        + (state.preview
          ? (state.fromRewards
              ? '<button type="button" class="gcp-cta gcp-cta--ghost" data-gc-exitpreview>' + esc(TX('back-to-rewards', null, 'Back to rewards')) + '</button>'
              : '<div class="gcp-pvactions">'
                  + '<button type="button" class="gcp-cta gcp-cta--ghost" data-gc-close>' + esc(TX('go-back', null, 'Go back')) + '</button>'
                  + '<button type="button" class="gcp-cta" data-gc-exitpreview>' + esc(TX('view-all-tiers', null, 'View all tiers')) + '</button>'
                + '</div>')
          : '');
    }

    
    requestAnimationFrame(function(){
      var railEl = grid.querySelector('.gcp-rail');
      if (railEl) restoreScroll(railEl, gcpRailLast, function(v){ gcpRailLast = v; });
      grid.querySelectorAll('.gcp-sw-rail').forEach(function(rail){
        var row = rail.querySelector('.gcp-sw-grid');
        if (row) restoreScroll(row, gcpSwLast, function(v){ gcpSwLast = v; });
        gcpSwArrows(rail);
      });
    });
  }

  
  function findChosen(cart, vid){
    var found = null;
    (cart.items || []).forEach(function(x){
      if (!found && x.properties && x.properties._gift_choice && (!vid || x.variant_id === vid)) found = x;
    });
    return found;
  }
  function removeChosen(vid){
    return getCart(true).then(function(cart){
      var it = findChosen(cart, vid);
      return it ? removeLine(it.key) : null;
    });
  }
  function pickGift(vid){
    if (state.busy) return;
    if (state.preview) return;   // browsing: nothing here adds to the cart
    
    state.bOpen = false; state.dvid = 0;
    state.busy = true; paintModal();
    
    var prev = state.picked, marker = state.marker, added = false;
    var chain = prev && prev !== vid ? removeChosen(prev) : Promise.resolve();
    chain
      .then(function(){
        if (prev === vid) return null;                  // tapping the chosen gift again is a no-op
        var props = { _gift_choice: 'true' };
        if (marker) props._Gifted = marker;
        return fetch('/cart/add.js', {
          method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
          body: JSON.stringify({ items:[{ id: vid, quantity: 1, properties: props }] })
        })
          .then(function(r){ if (!r.ok) throw new Error('add ' + r.status); added = true; return getCart(true); })
          .then(function(cart){
            var line = findChosen(cart, vid);
            if (!line) throw new Error('line missing');
            if (line.line_price !== 0) throw new Error('not free');
            return true;
          });
      })
      .then(function(ok){
        
        if (ok) closePopup();
      })
      .catch(function(err){
        if (window.console) console.warn('[gift choice] reward not added', err && err.message);
        var undo = added ? removeChosen(vid).catch(function(){}) : Promise.resolve();
        return undo.then(showPickError);
      })
      .then(function(){ state.busy = false; refreshCart(false); });
  }
  function removeLine(key){
    return fetch('/cart/change.js', {
      method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
      body: JSON.stringify({ id: String(key), quantity: 0 })
    });
  }
  function showPickError(){
    var dlg = document.querySelector('#gcp-modal .gcp-dialog');
    if (!dlg) return;
    var el = dlg.querySelector('.gcp-err');
    if (!el){
      el = document.createElement('p'); el.className = 'gcp-err'; el.setAttribute('role', 'alert');
      dlg.insertBefore(el, dlg.querySelector('.gcp-foot') || null);
    }
    el.textContent = TX('gift-add-failed', null, 'Your reward could not be added — please try again.');
    el.hidden = false;
    clearTimeout(el._t); el._t = setTimeout(function(){ el.hidden = true; }, 6000);
  }

  
  var reconciling = false;
  /* 31 Oct 2026 (Marwan: the free bracelet is not added). Shopify's cart is last write wins: a /cart/update.js sent while
     the gift's /cart/add.js is under way can save the cart as it was BEFORE the gift. The add answered 200, the gift was
     gone, and the next round read that as "the customer removed it" and never added it again (live: about 1 click in 10
     on a phone, _GiftRemoved on the order). So: the gift add waits for writes under way, other writes wait for the gift
     add (the fetch wrapper at the bottom), and the cart is read back once after the add. Nobody can remove a gift in the
     moment before it has even been drawn, so missing here is always this race: it goes back in, twice at most.
     A /cart/shipping_rates.json read does the same: it saves the cart it loaded when it ends (plain requests, 1 Nov: a rates
     read overlapping the gift add wiped the gift 4 times in 10). So rates wait for writes and the gift round, and writes
     wait for a rates read under way. */
  var ntfWrites = [], ntfGiftAddP = null, ntfRates = [], ntfReconP = null, ntfLastWrite = 0;
  function ntfCap(p){ return Promise.race([p, new Promise(function(res){ setTimeout(res, 4000); })]); }
  function ntfCartSettled(){ return ntfWrites.length ? ntfCap(Promise.all(ntfWrites.slice())) : Promise.resolve(); }
  function ntfRatesGate(){
    return ntfCap(Promise.all(ntfWrites.concat(ntfGiftAddP || [])))
      .then(function(){ return new Promise(function(res){ setTimeout(res, Math.max(0, ntfLastWrite + 400 - Date.now())); }); })
      .then(function(){ return ntfCap(Promise.resolve(ntfReconP)); })
      .then(ntfCartSettled);
  }
  function ntfPlaceGifts(adds, tries){
    adds.forEach(markPlaced); setPending(adds, true);
    var req = fetch('/cart/add.js', {
      method:'POST', keepalive:true, headers:{ 'Content-Type':'application/json', Accept:'application/json' },
      body: JSON.stringify({ items: adds.map(function(vid){
        return { id:+vid, quantity:1, properties:{ _auto_gift:'true' } };
      }) })
    });
    ntfGiftAddP = ntfCap(req.catch(function(){}));
    return req.then(function(r){
      ntfGiftAddP = null;
      setPending(adds, false);
      if (!r.ok){ adds.forEach(unmarkPlaced); if (window.console) console.warn('[gift] auto gift could not be added', r.status); return 'reconciled'; }
      return ntfCartSettled()
        .then(function(){ return new Promise(function(res){ setTimeout(res, 500); }); })
        .then(ntfCartSettled)
        .then(function(){ return getCart(true); })
        .then(function(cart){
          if (!cart || !cart.token) return 'reconciled';
          var lost = adds.filter(function(vid){
            return !(cart.items || []).some(function(it){ return String(it.variant_id) === String(vid); });
          });
          if (!lost.length || tries >= 2) return 'reconciled';
          if (window.console) console.warn('[gift] auto gift lost to another cart write, adding it again');
          return ntfPlaceGifts(lost, tries + 1);
        });
    }, function(e){ ntfGiftAddP = null; setPending(adds, false); throw e; });
  }

  /* _GiftRemoved means: the customer tapped the remove button on the free gift's own line, and the order has no gift (Kai,
     31 Oct 2026). Nothing else writes it. The tap is matched on the line key, because a paid line can be the same variant.
     The attribute is written once the gift has really gone, checked on the next read, and taken off when the gift is back. */
  var RM_TAP_KEY = 'ntf_gift_rm_tap', RM_TAP_MS = 60000, GIFT_KEYS_KEY = 'ntf_gift_keys';
  function ntfLs(k, v){ try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(v)); } catch(e){} return null; }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.ntf-remove'); if (!b) return;
    var key = String(b.id || '').replace(/^remove-/, ''), keys = ntfLs(GIFT_KEYS_KEY) || {};
    Object.keys(keys).forEach(function(vid){
      if (keys[vid] !== key) return;
      var d = new Date(), n2 = function(x){ return (x < 10 ? '0' : '') + x; };
      ntfLs(RM_TAP_KEY, { vid: vid, t: Date.now(), stamp: n2(d.getUTCMonth() + 1) + n2(d.getUTCDate()) + '.' + n2(d.getUTCHours()) + n2(d.getUTCMinutes()) });
      setTimeout(function(){ cartChanged(); reconcileAutoGifts(); }, 3000);
    });
  }, true);
  function ntfRmTapped(vid){ var t = ntfLs(RM_TAP_KEY); return !!t && t.vid === String(vid) && (Date.now() - t.t) < RM_TAP_MS; }
  function ntfSetRemovedAttr(v){
    return fetch('/cart/update.js', { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, keepalive:true,
      body: JSON.stringify({ attributes: { _GiftRemoved: v } }) }).catch(function(){});
  }

  function reconcileAutoGifts(){
    if (reconciling) return Promise.resolve();
    var el = payloadEl();
    if (!el) return Promise.resolve();
    var d = getData(el);
    var tiers = (d.tiers || []).filter(function(t){ return t.type === 'auto_gift' && t.autoVid; });
    if (!tiers.length) return Promise.resolve();

    reconciling = true;
    return ntfReconP = ntfCartSettled()   /* a write still under way could undo what this round reads or adds */
      .then(function(){ return getCart(true); })   /* force: a cached snapshot from before the last write makes reconcile add a duplicate */
      .then(function(cart){
        /* K11: a cart request cut off by a page change comes back as { items: [] } (getCart's fallback). Acting on it
           wrote "0 paid items", so the next page read the same cart as a fresh add and undid a removal. No token = no
           real cart: do nothing this round. */
        if (!cart || !cart.token) return null;
        var qualifying = qualifyingTotal(cart);

        var want = {};
        tiers.forEach(function(t){ if (qualifying >= t.th && autoGiftEligible(cart, t.autoVid)) want[t.autoVid] = 1; });
        
        var paidQty = 0;
        (cart.items || []).forEach(function(it){ var p = it.properties || {}; if (!(p._auto_gift || p._gift_choice || p._Gifted) && it.final_line_price > 0) paidQty += it.quantity; });
        ntfGiftTok = String(cart.token || '').split('?')[0] || ntfGiftTok;   /* the cart id only: the ?key= part is not stable */
        var prevPaid = null; try { prevPaid = sessionStorage.getItem('ntf_paid_qty'); } catch(e){}
        var ntfFreshPaid = paidQty > (+prevPaid || 0);
        try { sessionStorage.setItem('ntf_paid_qty', String(paidQty)); } catch(e){}

        
        
        var present = {}, have = {}, overQty = {};
        (cart.items || []).forEach(function(it){
          var gp = it.properties || {};
          if (gp._auto_gift || gp._Gifted || gp._gift_choice || !(it.final_line_price > 0)) present[it.variant_id] = true;
          if (it.properties && it.properties._auto_gift){
            /* a second free line of the same gift (two adds that crossed) is removed */
            if (have[it.variant_id] && have[it.variant_id] !== it.key) overQty[it.key] = 0;
            else if (have[it.variant_id] === it.key) overQty[it.key] = 1;   /* one line shown as two rows (free + paid): back to 1 */
            else have[it.variant_id] = it.key;
            
            if (it.quantity > 1 && overQty[it.key] !== 0) overQty[it.key] = 1;
          }
        });

        
        var removals = {}, changed = false;
        Object.keys(overQty).forEach(function(k){ removals[k] = overQty[k]; changed = true; });
        Object.keys(have).forEach(function(vid){
          if (!want[vid]){ removals[have[vid]] = 0; changed = true; }
        });
        
        var ntfKeys = {}; Object.keys(have).forEach(function(vid){ ntfKeys[vid] = have[vid]; }); ntfLs(GIFT_KEYS_KEY, ntfKeys);
        Object.keys(want).forEach(function(vid){
          /* A gift add killed by leaving the page also leaves the gift absent. Without a tap it is simply added again below. */
          if (!present[vid] && !isPending(vid) && ntfRmTapped(vid)) decline(vid);
        });
        if (ntfFreshPaid){ Object.keys(want).forEach(function(vid){ undecline(vid); }); ntfLs(RM_TAP_KEY, null); }
        var ntfAttr = (cart.attributes || {})._GiftRemoved, ntfTap = ntfLs(RM_TAP_KEY), ntfGone = Object.keys(want).some(function(vid){ return !present[vid] && isDeclined(vid); });
        if (ntfGone && !ntfAttr && ntfTap) ntfSetRemovedAttr(ntfTap.stamp);
        else if (ntfAttr && !ntfGone && Object.keys(want).some(function(vid){ return present[vid]; })){ ntfLs(RM_TAP_KEY, null); ntfSetRemovedAttr(''); }
        var adds = Object.keys(want).filter(function(vid){
          return !present[vid] && !isDeclined(vid) && !isPending(vid);
        });
        if (!changed && !adds.length) return null;

        if (window.console) console.info('[gift] reconciling auto gifts', { adds: adds, removals: removals });

        var chain = Object.keys(removals).length
          ? fetch('/cart/update.js', {
              method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
              body: JSON.stringify({ updates: removals })
            })
          : Promise.resolve();

        return chain.then(ntfCartSettled).then(function(){
          if (!adds.length) return 'reconciled';
          return ntfPlaceGifts(adds, 0);
        });
      })
      .catch(function(){ return null; })
      .then(function(res){ reconciling = false; return res; });
  }

  
  function enforceThreshold(){
    var el = payloadEl();
    if (!el) return Promise.resolve();
    var d = getData(el);
    var gi = giftTierIdx(d.tiers || []);
    if (gi === -1) return Promise.resolve();
    var th = d.tiers[gi].th;
    return getCart()
      .then(function(cart){
        var gifts = (cart.items || []).filter(function(it){
          return it.properties && it.properties._gift_choice;
        });
        if (!gifts.length) return null;
        if (qualifyingTotal(cart) >= th) return null;
        if (window.console) console.warn('[gift choice] cart fell below ' + th + ' — removing gift');
        
        return removeLine(gifts[0].key).then(function(){ return 'removed'; });
      })
      .catch(function(){ return null; });
  }

  
  function refreshCart(closeAfter){
    var ids = [];
    try { ids = Alpine.store('xCartHelper').getSectionsToRender().map(function(s){ return s.id; }); }
    catch(e){}
    fetch('/cart/update.js', {
      method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
      body: JSON.stringify({ updates:{}, sections: ids })
    })
      .then(function(r){ return r.json(); })
      .then(function(res){
        try { Alpine.store('xCartHelper').reRenderSections(res.sections); } catch(e){}
        try { Alpine.store('xCartHelper').currentItemCount =
          parseInt(document.getElementById('cart-icon-bubble').innerHTML); } catch(e){}
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      })
      .catch(function(){})
      .then(function(){
        setTimeout(function(){
          scanRows();
          if (state){
            getCart(true)
              .then(function(cart){
                var bases = cartBases(cart), chosen = 0;
                state.value = bases.post; state.orderDisc = bases.orderDisc;
                state.picked = null;
                state.cartVids = {};
                (cart.items || []).forEach(function(it){
                  state.cartVids[it.variant_id] = true;
                  if (it.properties && it.properties._gift_choice){
                    chosen += it.quantity; state.picked = it.variant_id;
                  }
                });
                state.chosen = chosen;
                paintModal();
                
                if (closeAfter) closePopup();
              })
              .catch(function(){ paintModal(); if (closeAfter) closePopup(); });
          }
        }, 150);
      });
  }

  
  document.addEventListener('click', function(e){
    
    var gchip = e.target.closest('[data-gc-giftchip]');
    if (gchip){
      e.preventDefault(); e.stopPropagation();
      document.dispatchEvent(new CustomEvent('ntf:open-gift-picker',
        { detail:{ preview: gchip.dataset.gcGiftchip === 'locked' } }));
      return;
    }
    var open = e.target.closest('[data-gc-open]');
    if (open){
      var row = open.closest('[data-gc-row]');
      if (row){ e.preventDefault(); openPopup(row); return; }
    }
    
    if (e.target.closest('[data-gc-explore]')){
      e.preventDefault(); closePopup();
      document.dispatchEvent(new CustomEvent('ntf:open-rewards-popup', { detail:{ explore: true } }));
      return;
    }
    if (e.target.closest('#gcp-close') || e.target.closest('[data-gc-close]')){ closePopup(); return; }
    if (e.target && e.target.id === 'gcp-modal'){ closePopup(); return; }
    var chooseBtn = e.target.closest('[data-gc-choose]');
    if (chooseBtn && state){
      
      e.preventDefault();
      state.openTier = null;
      paintModal();
      return;
    }
    var readd = e.target.closest('[data-gc-readd]');
    if (readd && state){
      e.preventDefault();
      var vid = +readd.dataset.gcReadd;
      
      undecline(vid);
      readd.disabled = true; readd.textContent = TX('adding', null, 'Adding…');
      cartChanged();
      reconcileAutoGifts()
        .then(function(){ return refreshCartVids(); })
        .then(function(){ refreshCart(false); })
        .catch(function(){ readd.disabled = false; readd.textContent = TX('add-it-back', null, 'Add it back'); });
      return;
    }
    var tierBtn = e.target.closest('[data-gc-tier]');
    if (tierBtn && state){
      e.preventDefault();
      var idx = +tierBtn.dataset.gcTier;
      
      if (state.T[idx] && state.T[idx].type === 'gift_choice'){
        state.preview = true; state.openTier = idx; paintModal(); return;
      }
      state.openTier = (state.openTier === idx) ? -1 : idx;
      paintModal();
      return;
    }
    var tog = e.target.closest('[data-gc-cs-toggle]');
    if (tog && state){ e.preventDefault(); state.cOpen = !state.cOpen; paintModal(); return; }
    var sw = e.target.closest('[data-gc-colour]');
    if (sw && state){ e.preventDefault(); state.bColour = sw.dataset.gcColour; state.cOpen = false; state.di = 0; paintModal(); warmColour(state.bColour); return; }
    
    if (state && state.cOpen && e.target.closest('#gcp-modal') && !e.target.closest('.gcp-cs')){
      state.cOpen = false; paintModal();
    }
    var sz = e.target.closest('[data-gc-size]');
    if (sz && state){ e.preventDefault(); state.bSize = sz.dataset.gcSize; state.di = 0; paintModal(); warmColours(true); warmColour(state.bColour, true); return; }
    
    var bopen = e.target.closest('[data-gc-bundle]');
    if (bopen && state){ e.preventDefault(); gcpRailKeep(); state.bOpen = true; state.dvid = 0; paintModal(); warmColour(state.bColour); return; }
    
    var view = e.target.closest('[data-gc-view]');
    if (view && state){ e.preventDefault(); gcpRailKeep(); state.dvid = +view.dataset.gcView; state.di = 0; paintModal(); return; }
    var dnav = e.target.closest('[data-gc-dnav]');
    if (dnav && state){
      e.preventDefault();
      gcpStep(+dnav.dataset.gcDnav); return;
    }
    
    var heroEl = e.target.closest('.gcp-split .gcp-hero');
    if (heroEl && state && currentGallery().length > 1){
      var hr = heroEl.getBoundingClientRect();
      gcpStep(e.clientX < hr.left + hr.width / 2 ? -1 : 1); return;
    }
    var dimg = e.target.closest('[data-gc-dimg]');
    if (dimg && state){ e.preventDefault(); state.di = +dimg.dataset.gcDimg; paintModal(); return; }
    
    var back = e.target.closest('[data-gc-back]');
    if (back && state){
      e.preventDefault(); closePopup();
      document.dispatchEvent(new CustomEvent('ntf:open-rewards-popup'));
      return;
    }
    var exitp = e.target.closest('[data-gc-exitpreview]');
    if (exitp && state){
      e.preventDefault(); closePopup();
      document.dispatchEvent(new CustomEvent('ntf:open-rewards-popup'));
      return;
    }
    var pick = e.target.closest('[data-gc-pick]');
    if (pick && state){ e.preventDefault(); pickGift(+pick.dataset.gcPick); return; }
  });
  
  document.addEventListener('change', function(e){
    var sel = e.target && e.target.closest ? e.target.closest('[data-gc-colour-select]') : null;
    if (sel && state){ state.bColour = sel.value; state.di = 0; paintModal(); warmColour(state.bColour); }
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    if (state && state.cOpen){ state.cOpen = false; paintModal(); return; }
    closePopup();
  });

  
  var mount = document.getElementById('x-cart-drawer-container');
  if (mount){
    var t = null;
    new MutationObserver(function(){
      clearTimeout(t);
      t = setTimeout(function(){ scanRows(); }, 80);
    }).observe(mount, { childList:true, subtree:true });
  }
  
  function drawerIsOpen(){
    try { return !!Alpine.store('xMiniCart').open; } catch(e){ return false; }
  }
  function restoreDrawer(wasOpen){
    if (!wasOpen) return;
    try {
      if (!Alpine.store('xMiniCart').open) Alpine.store('xMiniCart').open = true;
    } catch(e){}
  }

  var _fetch = window.fetch;
  window.fetch = function(){
    var url = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
    var isWrite = typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url);
    var self = this, args = arguments;
    if (typeof url === 'string' && url.indexOf('/cart/shipping_rates') > -1){
      return ntfRatesGate().then(function(){
        var q = _fetch.apply(self, args), t = q.catch(function(){}).then(function(){ ntfRates.splice(ntfRates.indexOf(t), 1); });
        ntfRates.push(t);
        return q;
      });
    }
    var ntfWait = isWrite && (ntfGiftAddP || ntfRates.length) ? ntfCap(Promise.all(ntfRates.concat(ntfGiftAddP || []))) : null;
    var p = ntfWait
      ? ntfWait.then(function(){ return _fetch.apply(self, args); })
      : _fetch.apply(this, arguments);
    if (isWrite){
      ntfLastWrite = Date.now();
      var ntfW = p.catch(function(){}).then(function(){ ntfLastWrite = Date.now(); ntfWrites.splice(ntfWrites.indexOf(ntfW), 1); });
      ntfWrites.push(ntfW);
      cartChanged();
      var wasOpen = drawerIsOpen();
      p.then(function(){
        setTimeout(function(){
          enforceThreshold()
            .then(function(r1){ return reconcileAutoGifts().then(function(r2){ return r1 || r2; }); })
            .then(function(changed){
              scanRows();
              
              if (changed) refreshCart(false);
            })
            .then(function(){
              
              restoreDrawer(wasOpen);
              setTimeout(function(){ restoreDrawer(wasOpen); }, 250);
            });
        }, 60);
      }).catch(function(){});
    }
    return p;
  };
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', scanRows);
  } else { scanRows(); }
  
  reconcileAutoGifts().then(scanRows);
})();
